import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCode, FaShoppingCart, FaChartLine } from 'react-icons/fa';
import './ServicesSection.css';

const ServicesSection = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <FaCode />,
      title: t('services.items.web.title'),
      description: t('services.items.web.description'),
      features: t('services.items.web.features', { returnObjects: true })
    },
    {
      icon: <FaShoppingCart />,
      title: t('services.items.ecommerce.title'),
      description: t('services.items.ecommerce.description'),
      features: t('services.items.ecommerce.features', { returnObjects: true })
    },
    {
      icon: <FaChartLine />,
      title: t('services.items.traffic.title'),
      description: t('services.items.traffic.description'),
      features: t('services.items.traffic.features', { returnObjects: true })
    }
  ];

  return (
    <section className="services-section" id="services">
      <div className="container">
        <h2 className="section-title">{t('services.title')}</h2>
        <p className="section-subtitle">
          {t('services.subtitle')}
        </p>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {Array.isArray(service.features) && service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 